@let isMenuPage = pageIs().menu;
@let isPromosTable = pageIs().promos;
@let isServicePage = pageIs().service;
@let isMorePage = pageIs().more;
@let callWaiterMain = this.callWaiterMain();

<div
  [class.hide]="hideTabBar()"
  class="tab-bar"
>
  <div class="tabs" coreActivitySection="TabBar">
    <button
      class="tab"
      [class.active]="isMenuPage"
      [routerLink]="isMenuPage ? '/main/home' : '/main/menu'"
      [coreUserActivityClickTracking]="isMenuPage ? 'MenuClose' : 'MenuOpen'"
    >

      <svg width="64" height="63" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M15.6 2.3c2 0 3.8 1.7 4 3.7v.2l.1 5a23.6 23.6 0 0 1 28.9 2.9c.6-2.8 1.6-5.6 3.1-8.9L52 5a4.6 4.6 0 0 1 4-2.3h.2c2.4.1 4.2 2 4.4 4.3V7l.7 47.8a5.7 5.7 0 1 1-11.4 0l.3-7.8a23.7 23.7 0 0 1-33.3 2.3l.2 5.4a5.7 5.7 0 1 1-11.5 0l1-28.2A6 6 0 0 1 2.9 21v-5.7l.1-9v-.2c.2-2.2 2-3.8 4.2-3.8h.2c.7 0 1.3.2 1.9.5.6-.3 1.3-.5 2-.5h.2c.7 0 1.4.2 2 .5.5-.3 1.3-.5 2-.5h.2Zm-.2 3c-.6 0-1.1.4-1.1 1l-.2 9.1v1a.7.7 0 0 1-1.4 0l-.3-10a1.1 1.1 0 0 0-2.3 0l-.2 10a.7.7 0 0 1-1.4 0l-.3-10a1.1 1.1 0 0 0-2.3 0l-.1 8.9V21a3 3 0 0 0 2.9 3c.5 0 1 .4 1 1L8.5 54.9c0 1.5 1 2.7 2.5 2.8h.3c1.5 0 2.7-1.2 2.7-2.7V55L12.8 25c0-.5.5-1 1-1a3 3 0 0 0 3.1-3V15.3l-.4-9c0-.6-.5-1-1-1Zm40.5.3c-.6 0-1.2.3-1.4.9A38.2 38.2 0 0 0 50.7 19l-.4 7.6c0 .7.5 1.2 1.1 1.3h1.1c.7 0 1.2.5 1.2 1.2L52.8 55c0 1.5 1 2.7 2.5 2.8h.2c1.5 0 2.6-1 2.7-2.4V55l-.7-47.8c0-1-.7-1.6-1.6-1.6Zm-23.6 5c-4.7 0-9 1.5-12.5 4.2v.5l.1 5.5a6 6 0 0 1-4 5.8l.7 18.4a20.7 20.7 0 0 0 33.7-3.3l.3-11c-1.9-.4-3.3-2-3.3-4.1a78.3 78.3 0 0 1 .6-8.9 20.7 20.7 0 0 0-15.6-7.1Z"
          fill="currentColor"/>
        <path
          d="M43.5 31.5A11.5 11.5 0 1 0 32 43v3h-.4c-7.7-.2-13.9-6.4-14-14.1v-.4C17.5 23.5 24 17 32 17h.4c7.8.2 14 6.6 14 14.5v.4a14.5 14.5 0 0 1-14.4 14v-3c6.3 0 11.5-5 11.5-11.4Z"
          fill="currentColor"/>
      </svg>
      <div class="label">Menu</div>
    </button>

    <button
      class="tab"
      [class.active]="isPromosTable"
      [routerLink]="isPromosTable ? '/main/home' : '/main/promos'"
      [coreUserActivityClickTracking]="isPromosTable ? 'PromosTableClose' : 'PromosTableOpen'"
    >

      <svg width="64" height="64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12.5 42.9c-4-4.1-6-6.1-6.8-8.8-.8-2.6-.1-5.4 1.2-11l.7-3.2c1.1-4.7 1.6-7 3.3-8.7 1.6-1.6 4-2.1 8.6-3.2l3.2-.7c5.6-1.3 8.4-2 11-1.2 2.7.7 4.7 2.8 8.8 6.8l4.8 4.8c7 7 10.6 10.6 10.6 15s-3.6 7.9-10.6 15c-7 7-10.6 10.5-15 10.5s-7.9-3.5-15-10.5l-4.8-4.8Z"
          stroke="currentColor" stroke-width="3"/>
        <circle cx="22.7" cy="23.8" r="5.3" transform="rotate(-45 22.7 23.8)" stroke="currentColor" stroke-width="3"/>
        <path d="m30.4 49 18.3-18.3" stroke="currentColor" stroke-width="3" stroke-linecap="round"/>
      </svg>
      <div class="label">Promos</div>
    </button>

    <button
      class="tab"
      [class.active]="isServicePage"
      [routerLink]="isServicePage ? '/main/home' : '/main/service'"
      [coreUserActivityClickTracking]="isServicePage ? 'ServiceClose' : 'ServiceOpen'"
    >

      <svg class="icon" width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M53.965 56.258h-43.93A7.566 7.566 0 0 1 2.47 48.69v-2.903H61.53v2.903a7.566 7.566 0 0 1-7.566 7.566ZM32 18.928a5.593 5.593 0 1 0 0-11.186 5.593 5.593 0 0 0 0 11.186Z"
          stroke="currentColor" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        <path
          d="M54.512 33.277c-3.95-8.475-12.545-14.35-22.512-14.35m0 0c-13.71 0-24.824 11.115-24.824 24.825v2.036H42.53M32 18.928c13.71 0 24.825 11.114 24.825 24.824v2.036"
          stroke="currentColor" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <div class="label">Service</div>
      <app-call-waiter-indicator
        [type]="callWaiterMain ? 'main' : 'bill'"
        class="indicator"
      />
    </button>

    <button
      class="tab"
      [class.active]="isMorePage"
      [routerLink]="isMorePage ? '/main/home' : '/main/more'"
      [coreUserActivityClickTracking]="isMorePage ? 'MoreClose' : 'MoreOpen'"
    >
      <svg class="icon" width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M53 18.875H11M53 32H11M53 45.125H11" stroke="currentColor" stroke-width="3" stroke-linecap="round"/>
      </svg>
      <div class="label">More</div>
    </button>
  </div>
</div>

@if (hideTabBar()) {
  <core-interacts-present/>
}
